export const CONSOLIDATE = 'consolidate'
export const SINGLE = 'single'
export const RETURN = 'return'
